let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g9jRX")).then(() => parcelRequire('3HEHB'));